import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            快速解答您对 91.cn 的常见疑问
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg border border-background-200 overflow-hidden"
            >
              <button
                type="button"
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`flex-shrink-0 text-lg text-foreground-500 transition-transform duration-200 ${
                    openIndex === index ? "ri-subtract-line rotate-180" : "ri-add-line"
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-700 leading-relaxed pt-1 border-t border-background-200">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}